const global = {
  colors: {
    primary: '#2858a2',
    white: '#fff',
    black: '#1d1d1b',
    disabled: '#dce0e6',
    gray: '#808080',
    error: '#c63236',
    errorBg: '#fff0f0',
    background: '#f7f8fa'
  },
  fontWeight: {
    thin: 100,
    exLight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    exBold: 800,
    black: 900
  },
  media: {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    tablet: '768px',
    desktop: '1200px',
    desktopL: '1366px'
  }
}

export {
  global as theme
}



// WEBPACK FOOTER //
// ./src/thems/base.js